import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { PageFormContainer } from 'components';
import { CounterpartyForm } from 'features/CounterpartyForm';

interface ParamTypes {
  option: 'create' | 'edit';
  id?: string;
}

export const CounterpartyFormPage: FC = () => {
  const { option, id } = useParams<ParamTypes>();

  return (
    <PageFormContainer>
      <CounterpartyForm option={option} id={id} />
    </PageFormContainer>
  );
};
